import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'contacto',
  type: 'node--contacto',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    apellidos: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'apellidos_contacto',
    },
    cargo: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'cargo_contacto',
    },
    dni: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'dni_contacto',
    },
    email: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'email',
    },
    nombre: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'nombre_contacto',
    },
    tel1: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'tel1',
    },
    tel2: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'tel2',
    },
  },
  relationships: {},
};
export const ContactoService = createService(base, configuration, API_CONFIG.API);
export const ContactoModule = createModule(ContactoService, true);



// WEBPACK FOOTER //
// ./src/models/contacto.js